/**
 * Centrix / Learnovate360 social-media destinations.
 *
 * Single source of truth for the social links rendered in the auth-shell footer
 * (and the marketing `ComingSoon` page). Keeping them here means the footer and
 * any other surface stay in lock-step, and the real destinations are not buried
 * as placeholder `#` anchors inside a component.
 */
export interface SocialLink {
  /** Stable key + accessible label (used as `aria-label`). */
  label: string;
  /** Absolute destination URL. */
  href: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  { label: 'Facebook', href: 'https://www.facebook.com/learnovate360' },
  { label: 'X (Twitter)', href: 'https://x.com/learnovate360' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/learnovate360' },
  { label: 'Instagram', href: 'https://www.instagram.com/learnovate360' },
] as const;
